module.exports = __webpack_public_path__ + "media/images/sp/maedori_photowedding/spot_05@3x-fe0b11b916ad6a5f627a2ac1d1f490ca.webp";